import type { FC, ReactNode } from 'react';
import { lazy, Suspense, useState } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import useAccess from '@/hooks/useAccess';

// Con lazy, la rama de src/fsd/ (que pasa su propio fallback) no descarga MUI por este guard.
const AuthorizationRequired = lazy(() => import('@/pages/AuthorizationRequired'));

interface Props {
  section: string;
  // Lo que se muestra sin acceso a la sección. Default: la página de autorización requerida.
  deniedFallback?: ReactNode;
}

const AmaruGuard: FC<Props> = (props) => {
  const { hasAccess, isAuthenticated } = useAccess();
  const {
    section,
    deniedFallback = (
      <Suspense fallback={null}>
        <AuthorizationRequired />
      </Suspense>
    ),
  } = props;
  const location = useLocation();
  const [requestedLocation, setRequestedLocation] = useState(null);

  if (!isAuthenticated()) {
    return <>{deniedFallback}</>;
  }

  // This is done so that in case the route changes by any chance through other
  // means between the moment of request and the render we navigate to the initially
  // requested route.
  if (requestedLocation && location.pathname !== requestedLocation) {
    setRequestedLocation(null);
    return <Navigate to={requestedLocation} />;
  }
  return hasAccess(section) ? <Outlet /> : <>{deniedFallback}</>;
};

export default AmaruGuard;
